import { useQueryClient } from '@tanstack/react-query'

import { invalidateFillApplication, type OwnerSuggestion } from '@/models/fillApplication'
import type { BusinessOwner } from '@/models/user'
import { OwnerSuggestionRow } from './OwnerSuggestionRow'

interface OwnerSuggestionsProps {
  orgId: string
  owner: BusinessOwner | null | undefined
  suggestions: OwnerSuggestion[]
}

export function OwnerSuggestions({ orgId, owner, suggestions }: OwnerSuggestionsProps) {
  const queryClient = useQueryClient()
  if (suggestions.length === 0) return null

  return (
    <div className="flex flex-col gap-2">
      <span className="text-ink-500 text-xs font-semibold tracking-wide uppercase">From the documents</span>
      <ul className="flex flex-col gap-2">
        {suggestions.map((suggestion) => (
          <OwnerSuggestionRow
            key={suggestion.id}
            orgId={orgId}
            owner={owner}
            suggestion={suggestion}
            onChanged={() => void invalidateFillApplication(queryClient, orgId)}
          />
        ))}
      </ul>
    </div>
  )
}
